/**
 * 国外期货行情页面 ts
 */
import { forEach } from 'lodash';
import QuoteTable from '../modules/quote_table/index'
import SwiperNav from '../modules/select_nav/index'
import { quoteUrl } from '../config/config'

declare var MobileSelect;

var data = {
    timer: null,
    quotaConfig: {
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        fs: [
            {
                params:'list/filter/0', // 主力
                listid:'0'
            },
            {
                params:'list/filter/1', // 夜盘
                listid:'1'
            },
            {
                params:'list/filter/2', // 主连
                listid:'2'
            },
            {
                params:'list/filter/3',// 期货指数
                listid:'3'
            },
            {
                params:'list/filter/113', // 上期所
                listid:'113'
            },
            {
                params:'list/filter/114', // 大商所
                listid:'114'
            },
            {
                params:'list/filter/115', // 郑商所
                listid:'115'
            },
            {
                params:'list/filter/142',// 上期能源
                listid:'142'
            },
            {
                params:'list/223', // 郑商所商品指数
                listid:null
            },
            {
                params:'list/filter/220',//中金所
                listid:'220'
            },
            {
                params:'list/filter/225',//广期所
                listid:'225'
            }
        ]
    },
    listid: 'list/filter/0',
    listidNav:'0',
    listconf: {
        fid: 'sp_all',
        mktid: '0',
        typeid: '0',
        listid: '0'
    },
    pz_size: 20,
    table:null,
    select:null,
    init: function () {
        let self = this
        self.table = self.initQuoteTable();
        self.mobileSelectInit();
        self.selectInit(self.listidNav);
        self.bindFun();
    },
    // 国外期货行情列表
    initQuoteTable: function(){
        let self = this
        if(self.listid == 'list/filter/8'){
            return self.makeZJQuoteTable()
        }else{
            return self.makeQuoteTable()
        }
    },
    makeQuoteTable: function () {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'nyhg',
            api: `${quoteUrl.getPath('qihuo2')}`,
            params: { // 默认参数配置
                sortkey: 'idx',
                sortval: 'asc',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            isProcess: true,
            sortdesc: 'desc',
            sortasc: 'asc',
            getUrl: function (url, params) {
                if (self.listid == 'list/223') {
                    return `${url}${self.listid}?pageSize=${params.size}&pageIndex=0&callbackName=?&sort=${params.sortval}&orderBy=${params.sortkey}`
                } else {
                    return `${url}${self.listid}?fid=${self.listconf.fid}&mktid=${self.listconf.mktid}&typeid=${self.listconf.typeid}&pageSize=${params.size}&pageIndex=0&callbackName=?&sort=${params.sortval}&orderBy=${params.sortkey}`
                }
            },
            dataProcess: function (data) {
                return data.list
            },
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td><p>${data.name}</p><p>${data.dm}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '')}">${data.p}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'p'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zdf > 0 ? 'shares-rise' : (data.zdf < 0 ? 'shares-fall' : '')}">${self.qhData(data.zdf, '%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zdf'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '')}">${data.zde}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zde'
                    }
                },
                {
                    name: 'zl',
                    title: '总手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.vol, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'vol'
                    }
                },
                {
                    name: 'ccl',
                    title: '持仓量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.ccl, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'ccl'
                    }
                },
                {
                    name: 'rzc',
                    title: '日增仓',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.rz > 0 ? 'shares-rise' : (data.rz < 0 ? 'shares-fall' : '')}">${self.conversion(data.rz, true, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'rz'
                    }
                },
                {
                    name: 'mr',
                    title: '买入',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            let color = data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '');
                            return `<td class="${data.mrj != '-' ? color : ''}">${data.mrj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'mrj'
                    }
                },
                {
                    name: 'mc',
                    title: '卖出',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            let color = data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '');
                            return `<td class="${data.mcj != '-' ? color : ''}">${data.mcj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'mcj'
                    }
                },
                {
                    name: 'tjd',
                    title: '投机度',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.tjd,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'tjd'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.cje, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'cje'
                    }
                },
                {
                    name: 'kp',
                    title: '开盘',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.o > data.zjsj ? 'shares-rise' : (data.o < data.zjsj ? 'shares-fall' : '')}">${data.o}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'o'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.h > data.zjsj ? 'shares-rise' : (data.h < data.zjsj ? 'shares-fall' : '')}">${data.h}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'h'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.l > data.zjsj ? 'shares-rise' : (data.l < data.zjsj ? 'shares-fall' : '')}">${data.l}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'l'
                    }
                },
                {
                    name: 'zf',
                    title: '振幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.qhData(data.zf,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zf'
                    }
                },
                {
                    name: 'zjs',
                    title: '昨结算',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${data.zjsj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zjsj'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
          let ad_height = $(".hqzx-usa")?.offset()?.top
          if($(".table-title")?.offset()?.top && $(".table-title")!.offset()!.top < 226 && ad_height){
            $(".table-title").css("top",$(".table-title")!.offset()!.top + ad_height + 'px')
          }
            if(e == undefined || e.list == null){
                $(".hsphb-more").html('暂无数据')
            }else{
                if(e.list.length < self.pz_size || e.list.length == e.total){
                    $(".hsphb-more").html('已经到底了')
                }else{
                    $(".hsphb-more").html('查看更多<i class="arrow-down"></i>')
                }
            }
        })
        return quotetable
    },
    makeZJQuoteTable: function () {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'nyhg',
            api: `${quoteUrl.getPath('qihuo2')}`,
            params: { // 默认参数配置
                sortkey: 'idx',
                sortval: 'asc',
                size: '20'
            },
            right_tds: 2,
            refresh: 15,
            isProcess: true,
            sortdesc: 'desc',
            sortasc: 'asc',
            getUrl: function (url, params) {
                if (self.listid == 'list/223') {
                    return `${url}${self.listid}?pageSize=${params.size}&pageIndex=0&callbackName=?&sort=${params.sortval}&orderBy=${params.sortkey}`
                } else {
                    return `${url}${self.listid}?fid=${self.listconf.fid}&mktid=${self.listconf.mktid}&typeid=${self.listconf.typeid}&pageSize=${params.size}&pageIndex=0&callbackName=?&sort=${params.sortval}&orderBy=${params.sortkey}`
                }
            },
            dataProcess: function (data) {
                return data.list
            },
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            return `<td><p>${data.name}</p><p>${data.dm}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '')}">${data.p}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'p'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zdf > 0 ? 'shares-rise' : (data.zdf < 0 ? 'shares-fall' : '')}">${self.qhData(data.zdf, '%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zdf'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '')}">${data.zde}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zde'
                    }
                },
                {
                    name: 'rzc',
                    title: '日增仓',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.rz > 0 ? 'shares-rise' : (data.rz < 0 ? 'shares-fall' : '')}">${self.conversion(data.rz, true, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'rz'
                    }
                },
                {
                    name: 'zl',
                    title: '成交量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.vol, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'vol'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.cje, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'cje'
                    }
                },
                {
                    name: 'ccl',
                    title: '持仓量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.ccl, false, true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'ccl'
                    }
                },
                {
                    name: 'mr',
                    title: '买价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            let color = data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '');
                            return `<td class="${data.mrj != '-' ? color : ''}">${data.mrj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'mrj'
                    }
                },
                {
                    name: 'mc',
                    title: '卖价',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            let color = data.zde > 0 ? 'shares-rise' : (data.zde < 0 ? 'shares-fall' : '');
                            return `<td class="${data.mcj != '-' ? color : ''}">${data.mcj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'mcj'
                    }
                },
                {
                    name: 'zjs',
                    title: '昨结算',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${data.zjsj}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: 'desc',
                        ascvalue: 'asc',
                        key: 'zjsj'
                    }
                }
            ]
        })
        let data = quotetable.init(true)
        data.then(function(e){
            if(e == undefined || e.list == null){
                $(".hsphb-more").html('暂无数据')
            }else{
                if(e.list.length < self.pz_size || e.list.length == e.total){
                    $(".hsphb-more").html('已经到底了')
                }else{
                    $(".hsphb-more").html('查看更多<i class="arrow-down"></i>')
                }
            }
        })
        return quotetable
    },
    selectInit: function (listidNav) {
        if(listidNav){
            let self = this
            $('.qh-filter').show()
            $('body').css({paddingBottom: '40px'})
            $.ajax({
                url: `${quoteUrl.getPath('qihuo2')}static/filter/barinfo/${listidNav}?callbackName=?`,
                type: 'GET',
                timeout: 15000,
                dataType: 'jsonp',
                success: function (data) {
                    // 获取获取过滤条件信息条
                    let navArr = []
                    let selectHtml = ``
                    if(data.list&&data.list.length > 0){
                        data.list.forEach((val,index)=>{
                            let o = {
                                name: val.fname,
                                value: {
                                    fid:val.fid,
                                    listid:val.listid,
                                    mktid:val.mktid,
                                    typeid:val.typeid
                                },
                                isSelect: index == 0 ? true : false
                            }
                            selectHtml += `<li class="${index == 0 ? 'active' : ''}" data-index=${index} data-fid=${o.value.fid} data-listid=${o.value.listid} data-mktid=${o.value.mktid} data-typeid=${o.value.typeid}>${o.name}</li>`
                            navArr.push(o)
                        })
                        // 生成底部滑动选择栏
                        self.select = new SwiperNav({
                            ele: 'qh-filter-nav',
                            navArr: navArr,
                            onclick: function (value, index, dom) {
                                self.listconf = value
                                self.table.destroy()
                                // 重新生成列表
                                self.table = self.initQuoteTable()
                                self.pz_size=20;
                                $.each($(`.qh-filter-menu-ul`).find('li'),function(){
                                    $(this).removeClass("active");
                                    if($(this).data('index') == index){
                                        $(this).addClass('active');
                                    }
                                })
                            }
                        })
                        self.select.init()
                        //生成底部右下角品种筛选
                        $('.qh-filter-menu-ul').html(selectHtml)
                        self.initSelectClick();
                    }
                },
                error: function (err) {
                    console.log(err)
                }
            })
        }else{
            $('.qh-filter').hide()
            $('body').css({paddingBottom: '0px'})
        }
    },
    mobileSelectInit: function () {
        var self = this;
        var mobileSelect1 = new MobileSelect({
            trigger: '#trigger',// 点击容器的ID
            title: '单项选择',// 
            wheels: [
                { data: ['主力', '夜盘', '主连', '期货指数', '上期所', '大商所', '郑商所', '上期能源', '郑商所商品指数', '中金所','广期所'] }
            ],
            position: [2], //Initialize positioning
            defaultselect: 1, //起始位置 1
            callback: function (index, data) {
                // 修改排行榜是市场
                self.listid = self.quotaConfig.fs[index - 1].params
                self.listidNav = self.quotaConfig.fs[index - 1].listid
                self.pz_size = 20
                // 切换列表 重置
                self.listconf = {
                    fid: 'sp_all',
                    mktid: '0',
                    typeid: '0',
                    listid: '0'
                }
                $("#market-title").html(data)
                $('.hsphb-more').html('查看更多<i class="arrow-down"></i>')
                // 取消旧市场定时刷新
                self.table.destroy()
                // 重新生成列表
                self.table = self.initQuoteTable();
                self.selectInit(self.listidNav);
                // let ad_height = $(".hqzx-usa")?.offset()?.top
                // setTimeout(()=>{
                //     if($(".table-title")?.offset()?.top && $(".table-title")!.offset()!.top < 226 && ad_height){
                //       // $(".hsqsc-title").css("top",origin_hsqsc_top + ad_height + 'px')
                //       $(".table-title").css("top",$(".table-title")!.offset()!.top + ad_height + 'px')
                //       }
                //   },90)
                }
        });
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
            if (num < 0) {
                numSign = '-'
            } else if (num == 0) {
                numSign = ''
            } else {
                numSign = ''
            }
        } else {
            numSign = ''
        }
        if (Math.abs(num) == 0) {
            return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
            return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
            return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
            return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
            return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 2)
            }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 1) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 1)
            }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 10000, 0) + '万'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 10000, 0)
            }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
            }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
            }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + '亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
            }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
            }
        } else if (Math.abs(num) >= 10000000000000) {
            if (isUnit) {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + '万亿'
            } else {
                return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
            }
        } else {
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
            return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
            return f
        } else {
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + n) {
                s += '0';
            }
            return s;
        }
    },
    dataProcess(data, symbol) {
        let self = this
        if (data == undefined || data == null || data == '-') {
            return '-'
        } else {
            return self.numberFix(data, 2) + symbol
        }
    },
    bindFun(){
        let self = this
        $('.hsphb-more').on('click', async function () {
            try {
                let data = await self.table.showMore(20)
                self.pz_size += 20
                let dataNum = data.list.length
                if (self.pz_size > dataNum) {
                    $(".hsphb-more").html('已经到底了')
                }
            } catch (error) {
                $(".hsphb-more").html('暂无数据')
            }
        });
        $('.qh-filter-select').on('click', async function () {
            $('.qh-filter-menu').show();
            $('.qh-layer').show();
        });
        $('.qh-layer').on('click',function(){
            $('.qh-filter-menu').hide();
            $('.qh-layer').hide();
        });
        $('.qh-filter-cancel').on('click',function(){
            $('.qh-filter-menu').hide();
            $('.qh-layer').hide();
        });
    },
    initSelectClick(){
        // 期货品种二级筛选点击事件
        let self = this;
        $('.qh-filter-menu-ul li').on('click',function(e){
            $.each($(`.qh-filter-menu-ul`).find('li'), function (e) {
                $(this).removeClass("active");
            })
            $(this).addClass('active');
            let obj = {
                fid:$(this).data('fid'),
                mktid:$(this).data('mktid'),
                typeid:$(this).data('typeid')
            }
            self.listconf = obj;
            self.pz_size=20;
            self.table.destroy();
            // 重新生成列表
            self.table = self.initQuoteTable();
            $('.qh-filter-menu').hide();
            $('.qh-layer').hide();
            self.select.goSlide($(this).data('index'));
        })
    },
    qhData(data, symbol) {
        if (data == undefined || data == null || data == '-') {
            return '-'
        } else if (data == 0) {
            return '0.00' + symbol
        } else {
            return data + symbol
        }
    }
}

data.init()